module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.canShowItemDescription) ? _c('div', {
    ref: "parent",
    staticClass: "cb-item__sub-group cb-item__captions"
  }, [_c('cb-slide-n-fade', [(_vm.freeQuantity) ? _c('div', {
    staticClass: "cb-item__captions-wrap"
  }, [_c('div', {
    staticClass: "cb-item__caption"
  }, [_vm._v("\n        " + _vm._s(_vm.ct('free_quantity.description', {
    units: _vm.freeQuantityToShow
  })) + "\n      ")])]) : _vm._e()]), _vm._v(" "), (_vm.showFirstSeparator) ? _c('div', {
    staticClass: "cb-item__separator"
  }) : _vm._e(), _vm._v(" "), _c('cb-slide-n-fade', [(_vm.canShowAmountSplit && (_vm.amountSplit.length == 1 || _vm.showMore)) ? _c('div', {
    staticClass: "cb-item__captions-wrap"
  }, [_c('cb-slide-n-fade', {
    attrs: {
      "is-list": true
    }
  }, _vm._l((_vm.amountSplit), function(split, index) {
    return _c('div', {
      key: index,
      staticClass: "cb-item__caption"
    }, [_c('span', {
      directives: [{
        name: "cb-html",
        rawName: "v-cb-html",
        value: (split.desc),
        expression: "split.desc"
      }]
    }), _vm._v(" "), (split.total) ? _c('span', {
      staticClass: "cb-item__total"
    }, [_vm._v(_vm._s(split.total))]) : _vm._e()])
  }))], 1) : _vm._e()]), _vm._v(" "), (_vm.canShowAmountSplit && _vm.canShowDescription) ? _c('div', {
    staticClass: "cb-item__separator"
  }) : _vm._e(), _vm._v(" "), _c('cb-slide-n-fade', [(_vm.canShowDescription) ? _c('div', {
    staticClass: "cb-item__captions-wrap"
  }, [_c('div', {
    directives: [{
      name: "cb-html",
      rawName: "v-cb-html",
      value: (_vm.sanitizeTags(_vm.description, ['BR'])),
      expression: "sanitizeTags(description, ['BR'])"
    }],
    staticClass: "cb-item__caption"
  })]) : _vm._e()]), _vm._v(" "), (_vm.showToggle) ? [(!_vm.showMore) ? _c('span', {
    staticClass: "cb-item__action",
    on: {
      "click": function($event) {
        _vm.toggleShowMore()
      }
    }
  }, [_vm._v(_vm._s(_vm.t('item.breakdown.show')))]) : _c('span', {
    staticClass: "cb-item__action",
    on: {
      "click": function($event) {
        _vm.toggleShowMore()
      }
    }
  }, [_vm._v(_vm._s(_vm.t('item.breakdown.hide')))])] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a98f9f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/ItemDescription.vue
// module id = 319
// module chunks = 24 34 35 36 37 43 66